import { useMemo, useState } from "react";

import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { useDescText } from "src/hooks/useDescText";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { DESC_FLD } from "src/utils/descLanguage/descLanguageUtil";

import {
	defaultKSK2140_R01Filter,
	useKSK2140_R01Store,
} from "./Store_KSK2140_R01";

export const SearchSection_KSK2140_R01 = () => {
	const { renderDescText, getFormTitleWidth } = useDescText();
	const { setCodeSearchModalProps } = useUiuxStore();
	const { KSK2140_R01Filter, setKSK2140_R01Filter } =
		useKSK2140_R01Store();
	const { compCdList, workPlaceList } = useCommonCodeStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });
	const searchLabels = useMemo(() => ({
		compCd: renderDescText(DESC_FLD.BUSINESS_SITE, "사업장"),
		productDate: renderDescText(DESC_FLD.PRODUCTION_DATE, "생산일자"),
		workplaceCd: renderDescText(DESC_FLD.WORK_PROCESS, "작업공정"),
		orderEmp: renderDescText(DESC_FLD.WORKER, "작업자"),
	}), [renderDescText]);
	const searchTitleWidths = useMemo(() => Object.fromEntries(
		Object.entries(searchLabels).map(([key, label]) => [
			key,
			getFormTitleWidth([label], 70, 180),
		]),
	), [getFormTitleWidth, searchLabels]);

	const handleOrderEmpFoucsId = "orderEmp_search";

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: "orderEmp",
			category: "작업자",
			focusId: handleOrderEmpFoucsId,
			responseMapping: {
				empNo: "orderEmp",
				empNm: "orderEmpNm",
			},
			extraFilter: () => ({
				orderEmp: KSK2140_R01Filter.orderEmp || "",
				orderEmpNm: KSK2140_R01Filter.orderEmpNm || "",
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: KSK2140_R01Filter,
		setEditData: setKSK2140_R01Filter,
		defaultData: defaultKSK2140_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: "KSK2140_R01_search",
	});

	return (
		<SearchSectionDoubleForm>
			<SearchDropDownForm
				label={searchLabels.compCd}
				titleWidth={searchTitleWidths.compCd}
				value={KSK2140_R01Filter.compCd}
				onChangeItem={(item) =>
					setKSK2140_R01Filter({ compCd: item?.compCd || "" })
				}
				optionList={compCdList}
			/>
			<SearchDateRangeForm
				label={searchLabels.productDate}
				titleWidth={searchTitleWidths.productDate}
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={KSK2140_R01Filter.dateRange}
				setDateRange={(dateRange) =>
					setKSK2140_R01Filter({ dateRange })
				}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			<SearchDropDownForm
				label={searchLabels.workplaceCd}
				titleWidth={searchTitleWidths.workplaceCd}
				value={KSK2140_R01Filter.workplaceCd}
				onChangeItem={(item) =>
					setKSK2140_R01Filter({ workplaceCd: item?.workplaceCd || "" })
				}
				optionList={workPlaceList.filter(
					(item) =>
						KSK2140_R01Filter.compCd === "" ||
						item.compCd === KSK2140_R01Filter.compCd,
				)}
			/>
			<SearchCodeModalForm
				label={searchLabels.orderEmp}
				titleWidth={searchTitleWidths.orderEmp}
				value={KSK2140_R01Filter.orderEmp}
				valueLabel={KSK2140_R01Filter.orderEmpNm}
				handleFoucsId={handleOrderEmpFoucsId}
				onChange={getFieldHandlers("orderEmp").onChange}
				onDoubleClick={getFieldHandlers("orderEmp").onDoubleClick}
				onKeyDown={getFieldHandlers("orderEmp").onEnterKeyDown}
				wrapperOption={{
					wrapperStyle: "w-[350px] min-w-[350px] mr-[10px]",
					titleStyle: "w-[70px] min-w-[70px] text-left",
					codeInputStyle: "w-[190px] min-w-[190px]",
					nameTagStyle: "w-[170px] min-w-[170px] text-left",
				}}
			/>
		</SearchSectionDoubleForm>
	);
};
